import React, { useEffect } from 'react';
import mqtt from 'mqtt';
import { useSelector } from 'react-redux';

function Mqqtdata({ setMqttTagData, topics, overViewTagData }) {
    const { selectTimeZoneProfile } = useSelector(state => state.userState);

    console.log("topicstopics", topics);

    // ✅ Helper to extract device UID from topic
    const getTagFromTopic = (topic) => {
        const marker = "DeviceUID/";
        const index = topic.indexOf(marker);
        return index !== -1 ? topic.slice(index + marker.length) : topic;
    };

    useEffect(() => {
        const mqttBrokerAddress = process.env.REACT_APP_MQTT_URL;
        const mqttUsername = process.env.REACT_APP_MQTT_USERNAME;
        const mqttPassword = process.env.REACT_APP_MQTT_PASSWORD;

        const { connect } = mqtt;

        const getTagTime = () => {
            return new Date().toLocaleTimeString('en-US', {
                timeZone: selectTimeZoneProfile || 'IST',
                hour12: false,
            });
        };

        const getTagDateAndTime = () => {
            return new Date().toLocaleString('en-US', {
                timeZone: selectTimeZoneProfile || 'IST',
                hour12: false,
            });
        };

        const getTagDateAndTimeFormat = () => {
            const options = {
                timeZone: selectTimeZoneProfile || 'IST',
                hour12: false,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            };

            const dateTimeString = new Date().toLocaleString('en-US', options);
            const [month, day, year, hour, minute, second] = dateTimeString.match(/\d+/g);
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        };

        const mqttClient = connect(mqttBrokerAddress, {
            username: mqttUsername,
            password: mqttPassword,
            rejectUnauthorized: false,
        });

        mqttClient.on('connect', () => {
            console.log('Connected to MQTT broker');
        });

        mqttClient.on('message', (topic, message) => {
            try {
                const messageString = message.toString();

                // ✅ Extract only the device UID part
                const tags = getTagFromTopic(topic);
                console.log("tagstagstags", tags);

                // More robust JSON parsing
                let data;
                try {
                    data = JSON.parse(messageString);
                    if (!Array.isArray(data)) {
                        data = [data];
                    }
                } catch (parseError) {
                    try {
                        data = JSON.parse(`[${messageString.replace(/}{/g, '},{')}]`);
                    } catch (secondError) {
                        const jsonObjects = messageString.match(/{[^{}]*}/g);
                        if (jsonObjects) {
                            data = jsonObjects
                                .map(obj => {
                                    try {
                                        return JSON.parse(obj);
                                    } catch (e) {
                                        return null;
                                    }
                                })
                                .filter(Boolean);
                        } else {
                            throw new Error("Unable to parse MQTT message as JSON");
                        }
                    }
                }

                const formattedMessage = data.map(obj => {
                    const device_tag = Object.keys(obj)[0];
                    const tagUnit = overViewTagData
                        ? overViewTagData.find(f => f.device__uid === tags && device_tag === f.device_tag)
                        : "";
                    const tagName = overViewTagData
                        ? overViewTagData.find(f => f.device__uid === tags && device_tag === f.device_tag)
                        : "";
                    const tagValue = obj[device_tag];

                    return {
                        tagValue,
                        device__uid: tags,
                        device_tag,
                        [device_tag]: tagValue,
                        tagName: tagName ? tagName.tag_name : "",
                        tagUnit: tagUnit ? tagUnit.tag_unit : "",
                        tagTime: getTagTime(),
                        tagDateAndTime: getTagDateAndTime(),
                        tagDateAndTimeFormat: getTagDateAndTimeFormat(),
                    };
                });

                setMqttTagData(prevData => {
                    const updatedData = { ...prevData };
                    const dataArray = updatedData[tags] || [];

                    const newObjMap = new Map(formattedMessage.map(obj => [obj.device_tag, obj]));

                    const updatedArray = dataArray.reduce((acc, item) => {
                        const newObj = newObjMap.get(item.device_tag);
                        if (newObj) {
                            acc.push(newObj);
                            newObjMap.delete(item.device_tag);
                        } else {
                            acc.push(item);
                        }
                        return acc;
                    }, []);

                    updatedArray.push(...newObjMap.values());

                    updatedData[tags] = updatedArray;
                    return updatedData;
                });
            } catch (error) {
                console.log("Error handling message: ", error);
            }
        });

        mqttClient.on('error', (error) => {
            console.log("MQTT error: ", error);
        });

        const intervalId = setInterval(() => {
            mqttClient.subscribe(topics);
        }, 3000);

        return () => {
            clearInterval(intervalId);
            mqttClient.end();
        };
    }, [topics, selectTimeZoneProfile]);

    return <div>{/* Your component JSX */}</div>;
}

export default Mqqtdata;
